import * as yup from 'yup';
import type { IValidationField } from '../types';
import type { IGenericObject } from 'types';
import { t } from 'i18next';
import paymentDueDate from './paymentDueDate';

export default function paymentTerms({ label = '', context: fieldContext = {} }: IValidationField) {
  const { isDebtOwner, labels } = fieldContext;
  const paymentDueLabel = labels?.paymentDue || '';

  return yup
    .object()
    .shape({
      paymentTermsCode: yup
        .string()
        .label(label)
        .notRequired()
        .test({
          name: 'required_payment_terms',
          test: (name, context) => {
            const {
              options: { from },
              path,
            } = context as IGenericObject;
            const [
              ,
              {
                value: { paymentTerms: { paymentTermsCode = '' } = {} },
              },
              { value: { debtOwner = 'false' } = {} } = {},
            ] = from;

            if (debtOwner === 'false' && !isDebtOwner && !paymentTermsCode) {
              return context.createError({
                message: t('errors.required', {
                  label,
                }),
                path,
              });
            }
            return true;
          },
        })
        .nullable()
        .default(''),
      paymentDueDate: paymentDueDate({ label: paymentDueLabel, type: 'paymentDueDate' }),
    })
    .default({});
}
